export class LocalSubplebbit {
    constructor() {
        throw Error("Local Subplebbit should not be instantiated in browser");
    }
}
